var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { SlideInPanel } from "uxp/components";
import { DataSourceBrowser } from "./DataSourceBrowser";
import './DataSourceBrowser.scss';
export const DataSourceBrowserModal = props => {
    const { show, onClose } = props, rest = __rest(props, ["show", "onClose"]);
    return React.createElement(SlideInPanel, { isOpen: show, onClose: onClose, direction: "right" },
        React.createElement(DataSourceBrowser, Object.assign({ onClose: onClose }, rest)));
};
